import {
  Armchair,
  Building2,
  CalendarDays,
  ClipboardList,
  FileText,
  FileUp,
  Info,
  MapPin,
  Megaphone,
  Mic,
  Settings,
  Sparkles,
  Tag,
  Users,
} from "lucide-react";

import type { PageTab } from "components/PageTabs";

const ALL_TABS: PageTab<string>[] = [
  { key: "settings", label: "Settings", icon: Settings },
  { key: "attendees", label: "Attendees", icon: Users },
  { key: "import", label: "Import", icon: FileUp },
  { key: "agenda", label: "Agenda", icon: CalendarDays },
  { key: "tracks", label: "Tracks", icon: Tag },
  { key: "seatings", label: "Seatings", icon: Armchair },
  { key: "signals", label: "Signals", icon: Sparkles },
  { key: "speakers", label: "Speakers", icon: Mic },
  { key: "partners", label: "Partners", icon: Building2 },
  { key: "venues", label: "Venues", icon: MapPin },
  { key: "resources", label: "Resources", icon: FileText },
  { key: "information", label: "Info", icon: Info },
  { key: "announcements", label: "Announcements", icon: Megaphone },
  { key: "feedback", label: "Feedback", icon: ClipboardList },
];

/** The Seatings tab is dropped while the feature is switched off. */
export function adminTabs(seatingsEnabled: boolean): PageTab<string>[] {
  return seatingsEnabled
    ? ALL_TABS
    : ALL_TABS.filter((tab) => tab.key !== "seatings");
}
